import { ORDER_APIS, PAYMENT_MODULE } from "@/api_framework/api_config";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => { });
type IQCUpdateAPIResponse = { status: boolean; message: string };

export interface IPaymentDebitNoteApproveReject {
  user_id: string;
  debit_note_receipt_id: "0001cd85-9be2-4c71-9cc5-5f330724e349";
  status: string;
  approve_ref_comment?: string;
}
// returns new created userId
export const usePaymentDebitNoteApproveRejectAPI = () => {
  const configuration = useConfiguration();
  const { captureError, toastNotification } = useAPIUtils();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (formData: IPaymentDebitNoteApproveReject) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key) as string;
        const requestHeaders = new Headers();
        requestHeaders.append("Authorization", `${accessToken}`);
        const response: IQCUpdateAPIResponse = await axios
          .patch(`${PAYMENT_MODULE?.DEBIT_REJECT_APPROVE?.baseURL}`, formData, {
            headers: { Authorization: requestHeaders.get("Authorization") },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true) {
              toastNotification(res.data.message);
              return { status: true, message: "batch" };
            } else {
              //   toast.error("Order data updated failed");
              return { status: false, message: "batch" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, message: "batch" };
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
